var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enableTool
    ? _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _c("control-layers", {
            attrs: {
              moduleCode: _vm.moduleCode,
              enableToolMapLayers: _vm.enableTool,
              posBtnMap: _vm.mapButtons.layers.position,
              idxBtnMap: _vm.mapButtons.layers.order,
              showLabelBtnMap: _vm.mapButtons.layers.showLabel,
              collapsible: _vm.mapButtons.layers.collapsible,
              collapsed: _vm.initialCollapsedExpandCollapse,
              showButtonOnActionMap: _vm.showButtonOnActionMap,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }